// class imagegalleryslider extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//         var autoplay = $(this).data('autoplay');
//       console.log("autoplay");
//         var swiper = new Swiper(
//           ".image-gallery--" + this.getAttribute("data-sectionid"),
//           {
//             slidesPerView: "auto",
//             observer: true,
//             observeParents: true,
//             spaceBetween: 20,

//               autoplay: {
//                 enabled = autoplay,
//                 delay: 2500,
//                 disableOnInteraction: false,
//               },
//             pagination: {
//               el: ".swiper-pagination",
//             },
//             breakpoints: {
//               769: {
//                 slidesPerView: "auto",
//                 spaceBetween: 30,
//               }
//             },
//           }
//         );

//     };
//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }
// customElements.define("image-gallery-slider", imagegalleryslider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            // $(".faq-accordion-wrapper")
            //   .find(".faq-answers")
            //   .removeClass("show");
            // $(".faq-accordion-wrapper").find(".faq-answers").slideUp(350);
            // $(".faq-accordion-wrapper").removeClass("active");
            // $(".faq-accordion-wrapper")
            //   .find(".fa-chevron-arrows")
            //   .find(".fa-chevron-down")
            //   .css({ display: "flex" });
            // $(".faq-accordion-wrapper")
            //   .find(".fa-chevron-arrows")
            //   .find(".fa-chevron-up")
            //   .css({ display: "none" });
            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);


class MainBlogTemplate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const self = this; // reference to <main-blog-template>

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(self);

      $(".custom-blog-tag").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // ✅ scroll immediately on click
        self.scrollIntoView({ behavior: "smooth", block: "start" });

        loadData($(this).attr("href"), $(this).parent().data("index"));

        $(".custom-blog-tag").removeClass("active");
        $(this).addClass("active");
      });

      function loadData(url, index) {
        $("main-blog-template .blog-grid-wrapper").css("text-align", "center");
        $("main-blog-template .blog-grid-wrapper").html(
          '<div></div><img style="text-align:center;width:60px;height:60px;margin:10rem auto 5rem;" src="https://cdn.shopify.com/s/files/1/0626/2105/7254/files/loading-gif.gif"/>'
        );

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const htmlmake = new DOMParser()
              .parseFromString(responseText, "text/html")
              .getElementsByClassName("main-blog-template")[0].innerHTML;

            $("main-blog-template").html(htmlmake);

            // rebind clicks for new content
            $(".custom-blog-tag").off("click").on("click", function (e) {
              e.preventDefault();
              e.stopPropagation();

              // ✅ scroll immediately on click
              self.scrollIntoView({ behavior: "smooth", block: "start" });

              loadData($(this).attr("href"), $(this).parent().data("index"));
              $(".custom-blog-tag").removeClass("active");
              $(this).addClass("active");
            });
          });
      }
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 400px 0px",
    }).observe(self);
  }
}

customElements.define("main-blog-template", MainBlogTemplate);

function printOnly(selector) {
  const el = document.querySelector(selector);
  if (!el) return;

  document.body.classList.add('printing');
  el.classList.add('print-target');

  const cleanup = () => {
    document.body.classList.remove('printing');
    el.classList.remove('print-target');
    window.onafterprint = null;
  };

  window.onafterprint = cleanup;
  window.print();
  setTimeout(cleanup, 1500); // safety cleanup
}

$(document).ready(function() {
  $('.bottom-button-conatiner').on('click', function() {
    printOnly('#container');
  });
});
